import React from 'react'
import itemCombo1 from '../assets/images/itemCombo1.png'
import itemCombo2 from '../assets/images/itemCombo2.png'
import itemCombo3 from '../assets/images/itemCombo3.png'
import {IconBlog, IconBusiness, IconFlight, IconHome, IconHotel, IconHunting, IconMotel} from './icons'
import {ValidationForm} from "./interface";

export const COMMON_TYPE_REDUCER = {
    SHOW_LOADING: 'SHOW_LOADING',
    TOGGLE_VIEW_HOTEL_IN_MAP: 'TOGGLE_VIEW_HOTEL_IN_MAP',
    SHOW_LOADING_GIU_CHO: 'SHOW_LOADING_GIU_CHO',
    TOGGLE_SIDE_BAR_MOBILE: 'TOGGLE_SIDE_BAR_MOBILE',
    TOGGLE_REVIEW_INFO: 'TOGGLE_REVIEW_INFO',
    TOGGLE_ALERT_BOX: 'TOGGLE_ALERT_BOX',
    TOGGLE_ALERT_BOX_TEXT: 'TOGGLE_ALERT_BOX_TEXT',
    TOGGLE_ALERT_BOX_LINK: 'TOGGLE_ALERT_BOX_LINK',
}

export const FLIGHT_TYPE_REDUCER = {
    SET_FLIGHT_SELECTED_DEPARTURE: 'SET_FLIGHT_SELECTED_DEPARTURE',
    SET_FLIGHT_SELECTED_RETURN: 'SET_FLIGHT_SELECTED_RETURN',
    SET_SEARCH_FLIGHT_CURRENT_TYPE: 'SET_SEARCH_FLIGHT_CURRENT_TYPE',
}

export const CHECKOUT2_TYPE_REDUCER = {
    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
    SET_REFRESH_PAGE: 'SET_REFRESH_PAGE',
    SET_VALUE_PROGRESS: 'SET_VALUE_PROGRESS',
    SHOW_LOADING_COMPONENT: 'SHOW_LOADING_COMPONENT',
    SHOW_LOADING_GIUCHO: 'SHOW_LOADING_GIUCHO',
}

export const PATH_PAY_ZALO_WALLET = '/thanh-toan/zalo-wallet'
export const PATH_PAY_FAIL = '/thanh-toan/that-bai'
export const PATH_PAY_WAITING_CONFIRM = '/thanh-toan/cho-xac-nhan'
export const PATH_PAY_BANK_TRANSFER = '/thanh-toan/chuyen-khoan'
export const PATH_PAY_WAITING_APPROVAL = '/thanh-toan/cho-duyet'
export const PATH_PAY_SUCCESS = '/thanh-toan/thanh-cong'

export const STATIC2_VNTRIP = 'https://i.vntrip.vn'
export const STATIC_VNTRIP = 'https://statics.vntrip.vn'
export const HOTEL_NO_IMAGE = 'https://statics.vntrip.vn/website/images/no-image.165x177.png'

export const USER_SESSION_KEY = 'user_info'
export const WEB_VIEW = 'webviewSessionInfo'
export const SESSION_APP = ['1056f523cbc6da6d5b7b0d96e7745344043422e1e8fbf1472356cb7e150a7353a097e5', 'e753cd61a2efcbef7a3a763415baa94331af91d8fd3ad5068b3492fcbc2cef17f7c567']
export const DEFAULT_NUMBER_PAGE_DSIPLAY = 3

export const LIST_COMBO_TEST: any = [
    {
        id: 1552,
        name: 'Combo VinHoliday 1 & Vé khu vui chơi (tuỳ chọn Vé Vinwonders và Vinpearl Safari)',
        image: itemCombo1,
        note: [
            { text: 'Đêm nghỉ tại Vinpearl, ăn sáng & Vé máy bay khứ hồi ' },
            { text: 'Giá chưa bao gồm vé khu vui chơi' },
        ],
        type_combo: '3 ngày 2 đêm',
        price: 3499000,
        province_id: 68,
        code: 'PQC',
        tip: 'Giá áp dụng cho nhóm 2 người',
    },
    {
        id: 2,
        name: 'Combo VinHoliday 1 & Vé khu vui chơi (tuỳ chọn Vé Vinwonders và Vinpearl Safari)',
        image: itemCombo2,
        note: [
            { text: 'Đêm nghỉ tại Vinpearl, ăn sáng & Vé máy bay khứ hồi ' },
            { text: 'Giá chưa bao gồm vé khu vui chơi' },
        ],
        type_combo: '3 ngày 2 đêm',
        price: 3499000,
        province_id: 68,
        code: 'PQC',
        tip: 'Giá áp dụng cho nhóm 2 người',
    },
    {
        id: 3,
        name: 'Combo VinHoliday 1 & Vé khu vui chơi (tuỳ chọn Vé Vinwonders và Vinpearl Safari)',
        image: itemCombo3,
        note: [
            { text: 'Đêm nghỉ tại Vinpearl, ăn sáng & Vé máy bay khứ hồi ' },
            { text: 'Giá chưa bao gồm vé khu vui chơi' },
        ],
        type_combo: '3 ngày 2 đêm',
        price: 3499000,
        province_id: 68,
        code: 'PQC',
        tip: 'Giá áp dụng cho nhóm 2 người',
    },
]

export const PASSENGER_CONST = {
    ADT_ASC: 'ADULT_ASC',
    ADT_DESC: 'ADULT_DESC',
    CHD_ASC: 'CHILD_ASC',
    CHD_DESC: 'CHILD_DESC',
    INF_ASC: 'INFANT_ASC',
    INF_DESC: 'INFANT_DESC',
}

export const FL_DEP = 'DEPARTURE'

export const FL_RET = 'RETURN'

export const ONE_WAY = 'ONE_WAY'

export const TWO_WAY = 'TWO_WAY'

export const MULTI_WAY = 'MULTI_WAY'

export const VNTRIP_INFO = {
    name: 'Công ty TNHH CÔNG NGHỆ VNTRIP',
    address1: 'Số 10/55 Thụy Khuê',
    address2: 'Phường Thuỵ Khuê, Quận Tây Hồ, Thành phố Hà Nội, Việt Nam',
    email: 'cs@vntrip.vn',
    hotline: '096 326 6688',
    appStore: 'https://itunes.apple.com/us/app/vntrip-at-phong-khach-san/id1046183734?ls=1&mt=8',
    googlePlay: 'https://play.google.com/store/apps/details?id=vn.vntrip.hotel',
}
export const COMPANY_NAME = 'Công ty TNHH CÔNG NGHỆ VNTRIP'

export const HOT_LINE = '096 326 6688'

export const LIST_ROUTER_MENU_MOBILE = [
    {
        key: 'home',
        label: 'Trang chủ',
        link: '/',
        isOpenNewTab: false,
        icon: () => <IconHome />,
    },
    {
        key: 'hunting',
        label: 'Săn giá rẻ',
        link: 'https://www.vntrip.vn/',
        isOpenNewTab: true,
        icon: () => <IconHunting />,
    },
    {
        key: 'hotel',
        label: 'Khách sạn',
        link: 'https://www.vntrip.vn/khach-san',
        isOpenNewTab: true,
        icon: () => <IconHotel width={18} height={18} />,
    },
    {
        key: 'flight',
        label: 'Vé máy bay',
        link: 'https://www.vntrip.vn/ve-may-bay',
        isOpenNewTab: true,
        icon: () => <IconFlight />,
    },
    {
        key: 'quickstay',
        label: 'Nhà nghỉ',
        link: 'https://quickstay.vntrip.vn/',
        isOpenNewTab: true,
        icon: () => <IconMotel />,
    },
    {
        key: 'business',
        label: 'Doanh nghiệp',
        link: 'https://tms.vntrip.vn/',
        isOpenNewTab: true,
        icon: () => <IconBusiness />,
    },
    {
        key: 'blog',
        label: 'Cẩm nang',
        link: 'https://www.vntrip.vn/cam-nang',
        isOpenNewTab: true,
        icon: () => <IconBlog />,
    },
]

export const DEFAULT_VALIDATION: ValidationForm = {
    status: 'success',
    text: '',
}
